import script from "./BaseAutocomplete2.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAutocomplete2.vue?vue&type=script&setup=true&lang=js"

import "./BaseAutocomplete2.vue?vue&type=style&index=0&id=59a475f6&scoped=true&lang=scss"
import "./BaseAutocomplete2.vue?vue&type=style&index=1&id=59a475f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a475f6"]])

export default __exports__